import request from '@/utils/http';

// 车次查询接口
export const search = (params) => {
    return request({
        url: '/api-tms/algorithm/line/detail/search',
        method: 'post',
        data: params
    });
};

// 排车接口
export const dispatchSave = (params) => {
    return request({
        url: '/api-tms/dispatch/algorithm/save/v2',
        method: 'post',
        data: params
    });
};
// 排车编辑
export const getDispathOrderPreservation = (data) => {
    return request({
        url: `/api-tms/dispatch/updateeditdispatchinfo`,
        method: 'put',
        data
    });
};

// 车次作废
export const cancelTrainNum = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/cancel`,
        method: 'post',
        data
    });
};

// 调整页面>>数据显示, 数据查询接口
// cancelFlag 参数：1 只返回 “已废除”运单，0 返回除“已废除”之外的运单，不穿返回所有运单
export const lineDetailWithOrder = (params) => {
    return request({
        'url': '/api-tms/algorithm/line/order/search',
        method: 'post',
        data: params
    });
};

export const getDetailStatistics = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail/count`,
        method: 'post',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 采纳
export const adoptApi = (data) => {
    return request({
        url: `/api-tms/algorithm/line/detail/adopt`,
        method: 'post',
        data
    });
};
// 获取服务平台配置
export const getSiteCodeList = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/algorithm/operator/queryLatest`,
        method: 'get',
        params: data
    });
};
// 获取预设区域数据
export const getLayerIdListApi = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/presupposeLayer/queryBySiteCode`,
        method: 'post',
        data
    });
};
// 排车低载率卡控发起审批流接口
export const createIflow = (data) => {
    return request({
        url: '/api-tms/loadRate/iflow/create',
        method: 'post',
        data
    });
};
